<template>
  <v-card>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="consulta()"
    >
      <v-card-title>
        Consulta
        <v-spacer/>
        <v-btn
            icon
            @click="$emit('close')"
        >
          X
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12">
            <v-text-field
                :loading = "loading"
                v-model="cuenta"
                label="Cuenta *"
                outlined
                autofocus
                maxlength="7"
                @keyup.enter="consulta"
                class=""
                :rules="[v => !!v || 'Cuenta es requerida']"
                @keypress="patterns.onlyNumber($event)"
                clearable
            />
          </v-col>
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="3" md="3">
                <template v-for="(c,i) in consumos">
                <v-text-field label="cuenta" :value="c.pla_matr+c.pla_dive" :key="i"  outlined disabled />
<!--                <v-text-field label="tarifa" :value="c.pla_tari" :key="i"  outlined disabled />-->
<!--                <v-text-field label="pla_fpag" :value="c.pla_fpag" :key="i"  outlined disabled />-->
                </template>
              </v-col>
              <v-col cols="3" md="3">
                <template v-for="(c,i) in consumos">
<!--                  <v-text-field label="cuenta" :value="c.pla_matr+c.pla_dive" :key="i"  outlined disabled />-->
                  <v-text-field label="tarifa" :value="c.pla_tari" :key="i"  outlined disabled />
<!--                  <v-text-field label="pla_fpag" :value="c.pla_fpag" :key="i"  outlined disabled />-->
                </template>
              </v-col>
              <v-col cols="4" md="4">
                <template v-for="(c,i) in consumos">
                  <!--                  <v-text-field label="cuenta" :value="c.pla_matr+c.pla_dive" :key="i"  outlined disabled />-->
<!--                  <v-text-field label="tarifa" :value="c.pla_tari" :key="i"  outlined disabled />-->
                  <v-text-field label="pla_fpag" :value="c.pla_fpag" :key="i"  outlined disabled />
                </template>
              </v-col>
              <v-col cols="2" md="2">
                <template v-for="(c,i) in consumos">
                  <!--                  <v-text-field label="cuenta" :value="c.pla_matr+c.pla_dive" :key="i"  outlined disabled />-->
                  <v-text-field label="n fac" :value="c.pla_nfac" :key="i"  outlined disabled />
                  <!--                  <v-text-field label="pla_fpag" :value="c.pla_fpag" :key="i"  outlined disabled />-->
                </template>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="3" md="3">
                <template v-for="(c,i) in otrosingresos">
                  <v-text-field label="cuenta" :value="c.pag_matr+c.pag_dive" :key="i"  outlined disabled />
                </template>
              </v-col>
<!--              <v-col cols="3" md="3">-->
<!--                <template v-for="(c,i) in otrosingresos">-->
<!--                  <v-text-field label="tarifa" :value="c.pla_tari" :key="i"  outlined disabled />-->
<!--                </template>-->
<!--              </v-col>-->
              <v-col cols="4" md="4">
                <template v-for="(c,i) in otrosingresos">
                  <v-text-field label="pla_fpag" :value="c.pag_fpag" :key="i"  outlined disabled />
                </template>
              </v-col>
              <v-col cols="5" md="5">
                <template v-for="(c,i) in otrosingresos">
                  <v-text-field label="num fac" :value="c.num_fact" :key="i"  outlined disabled />
                </template>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
<!--      <v-footer>-->
<!--        <v-spacer/>-->
<!--        <v-btn-->
<!--            color="primary"-->
<!--            type="submit"-->
<!--            :loading="loading"-->
<!--        >-->
<!--          Duplicar factura-->
<!--        </v-btn>-->
<!--      </v-footer>-->
    </v-form>
    <div id="myElement">
    </div>
  </v-card>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {duplicacionStore} from "@/store/duplicacionStore";
import {Duplicacion} from "@/models/Duplicacion";
import {Pattern} from "@/addons/Pattern";
import {DuplicacionService} from "@/services/DuplicacionService";
import {recaudacionStore} from "@/store/recaudacionStore";
import {PrintConsumo} from "@/addons/PrintConsumo";

@Component({
  name: "Consulta"
})

export default class Consulta extends Vue {
  private patterns = Pattern;
  private duplicacionStore = duplicacionStore();
  private duplicacionService = DuplicacionService.getInstance();
  private recaudacionStore = recaudacionStore();

  cuenta = null;
  nfac = null;
  consumos = {};
  otrosingresos = {};
  loading = false;
  motivo = {
    "cod": "1",
    "descripcion": "POR DESPERFECTO"
  };

  valid = true;
  $refs!: {
    form: HTMLFormElement
  };

  // get loading(): boolean {
  //   return this.duplicacionStore.loading;
  // }

  get duplicacion(): Duplicacion {
    return this.duplicacionStore.duplicacion;
  }

  get motivos(): any[] {
    return this.duplicacionStore.motivos;
  }

  mounted() {
    this.duplicacionService.getMotivosDuplicacion();
  }

  consulta() {
    if (!this.$refs.form.validate()) {
      return;
    }

    const data = {
      cuenta: this.cuenta
    }
    // console.log(this.cuenta);
    this.loading= true;
    this.duplicacionService.consultaDuplicacion(data).then((res: any) => {
      this.consumos = res.planillas;
      // console.log(this.consumos);
      this.otrosingresos = res.otrosingre;
      this.loading= false;
      // if (res.success) {
      //   this.resetFields();
      //   this.imprimir(res);
      // }
    });
  }

  private imprimir(res: any) {
    const printConsumo = new PrintConsumo();
    printConsumo.imprimir(res.factura, res.cliente, true);
  }

  private resetFields() {
    this.cuenta = null;
    this.nfac = null;
    this.motivo = {
      "cod": "1",
      "descripcion": "POR DESPERFECTO"
    };
  }
}
</script>

<style scoped>

</style>